module.exports = __webpack_public_path__ + "static/media/B1_NORM.c3c1650b.png";